import React from 'react';
import { dateFormatWithLeadingZeroForMonth } from 'utilities/formatDate';
import {
  mapDataToLabelAndValue,
  formatJobLocation,
  IJobLocationAddress,
} from 'modules/hiring/utilities';
import { ICandidateProfileApplicationHistory } from 'modules/hiring/models/candidateProfile.model';
import { ICandidateApplicationDataObject } from './candidateApplicationDetails';
import CandidateModalResume from './candidateModalResume';
import { getEmployeeFullName } from 'utilities/utilityFunctions';
import { ICandidateApplicationDetailsWidgetData } from '../candidateFeedBackForm/candidateApplicationDetailsWidget';
import { useTranslation } from 'react-i18next';

export interface IObjectData {
  [key: string]: {
    [key: string]: string | undefined | React.ReactNode | React.ReactElement;
  };
}
export interface IMappedObjectData {
  [key: string]: ICandidateApplicationDataObject;
}

type TcandidateApplicationVariant = 'modal' | 'widget';

export const mapCandidateApplicationFormData = (
  application?: ICandidateProfileApplicationHistory,
  variant?: TcandidateApplicationVariant
) => {
  let data: IObjectData = {};
  /* istanbul ignore else */
  if (variant === 'modal') {
    data.profile = {
      resume: (
        <CandidateModalResume
          candidateId={application?.candidateId}
          candidateName={getEmployeeFullName({
            firstName: application?.firstName!,
            lastName: application?.lastName,
          })}
          fromFullProfile={false}
        />
      ),
    };
  }
  const addressLine1 = application?.address?.address_line1;
  const addressLine2 = application?.address?.address_line2;
  const city = application?.address?.city;
  const state = application?.address?.state;
  const country = application?.address?.country;

  const homeLocation = [addressLine1, addressLine2, city, state, country]
    .filter(Boolean)
    .join(', ');

  data = {
    profile: {
      ...data.profile,
      firstName: application?.firstName,
      lastName: application?.lastName,
      eMail: application?.email,
      phone: application?.phone,
      country: application?.address?.country,
      location: homeLocation || '',
    },
    address: {
      city: application?.address?.city,
      state: application?.address?.state,
      zipCode: application?.address?.postal_code,
    },
  };
  return mapDataToLabelAndValue(data);
};

export const mapAppliedCandidateDetailsData = (
  application?: ICandidateProfileApplicationHistory
) => {
  const { t: translate } = useTranslation();
  const data: IObjectData = {
    application: {
      jobTitle: `${application?.jobTitle} (${application?.requisitionID})`,
      applicationStage: application?.applicationStage,
    },
    other: {
      jobLocation: formatJobLocation(
        application?.job_location_address as IJobLocationAddress
      ),
      dateApplied: application?.applicationDate
        ? dateFormatWithLeadingZeroForMonth(application?.applicationDate ?? '')
        : translate('notAvailable')?.toString(),
    },
  };
  return mapDataToLabelAndValue(data);
};

export const mapCandidateApplicationDetailsWidgetData = (
  application?: ICandidateProfileApplicationHistory
) => {
  const { t: translate } = useTranslation();
  const data: ICandidateApplicationDetailsWidgetData = {
    jobTitle: `${application?.jobTitle} 
          ${
            application?.requisitionID ? `(${application?.requisitionID})` : ''
          }`,
    jobLocation:
      formatJobLocation(
        application?.job_location_address as IJobLocationAddress
      ) ?? '',
    dateApplied: application?.applicationDate
      ? dateFormatWithLeadingZeroForMonth(application?.applicationDate ?? '')
      : translate('notAvailable'),
    recruiterName: application?.recruiterName ?? '',
  };
  return data;
};
